import {$, w} from './constants';

const calculate_vh = () => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}

w.load(() => {
    console.log('Hello world from El Cultivo! --Load');
    calculate_vh();

    //Áreas de práctica
    $('.area-trigger').click(function(event){
        event.preventDefault();
        let target = $(this).attr('data-href');
        $(target).data('status', 'open');
        $(target).attr('data-status', 'open');
        $('html, body').animate({
            scrollTop: $(target).offset().top - 120
        }, 1000);
    })
    $('.areas__content-block').click(function(event){
        event.stopPropagation();
       if( $(this).attr('data-status') === "open"){
            $(this).data('status', 'close');
            $(this).attr('data-status', 'close');
       }else{
            $(this).data('status', 'open');
            $(this).attr('data-status', 'open');
       }
       $(this).children('.areas__content-block-content').click(function(e){
           e.preventDefault();
           e.stopPropagation();
       })
    })
});

$(document).ready(function() {
    console.log('Hello world from El Cultivo! --Ready');

    //Cookies
    if(localStorage.getItem('celeste_zinser')){
        $('#cookie-zinser').addClass('hide');
    }else{
        $('#cookie-zinser').delay(900).addClass('show');
        $('#ok-cookie').click(() => {
            localStorage.setItem('celeste_zinser', 'true');
            $('#cookie-zinser').toggleClass(' show hide');
            console.log('Acepto cookies')
        })
    }
    $('#trigger-open-menu').click(function(){
        $('#menu-aside').addClass('show');
    });

    $('#trigger-close-menu').click(function(){
        $('#menu-aside').removeClass('show');
    });

    const actualBtn = document.getElementById('cv');

    const fileChosen = document.getElementById('file-chosen');

    //Contacto
    $("#contact").validate({
        rules: {
            name : {
                required: true
            },
            phone: {
                required: true,
                number: true
            },
            email: {
                required: true,
                email: true
            },
            cv: {
                accept: "pdf"
            }
        },
        errorClass : "error-contact",
        errorElement: "label",
        submitHandler: function(form) {
            event.preventDefault();
            $('#submit').prop('disabled', true);
			
            let formData = new FormData( form );
            let portfolio = document.getElementById('cv').files[0];

            formData.append('action', 'contact');
            formData.append('portfolio', portfolio);

            $.ajax({
                url: cltvo_js_vars.ajax_url,
                type: form.method,
                data: formData,
                contentType: false,
                processData: false,
                success: function(response) {
                    $('#name').val('');
                    $('#phone').val('');
                    $('#email').val('');
                    $('#cv').val('');
                    fileChosen.textContent = '  ';
                    $('#submit').prop('disabled', true);
                    $('#success').html('¡Gracias! Nos comunicaremos contigo a la brevedad');
                },
                error: function( error ){
                    $('#error').text( error.responseJSON.message );
                }
            });
        }
    });

    //->Fix para file personalizado

    if($(actualBtn).length){
        actualBtn.addEventListener('change', function(){
            fileChosen.textContent = this.files[0].name
        });
    }

    /* $(window).scroll(function (event) {
        const nav = $('.header');

        if($(this).scrollTop() > nav.height()){
            $('.header').addClass('change');
        }else{
            $('.header').removeClass('change');
        }
    }); */

})

w.on('resize', function(){
    if( w.width() >= 650 ){
        calculate_vh();
    }
})
